// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Label from '../../components/Label';
import SvgIconStyle from '../../components/SvgIconStyle';
import { Children } from 'react';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  customer: getIcon('customer'),
  car: getIcon('ic_car'),
  driver: getIcon('ic_driver'),
  transactions: getIcon('transactions'),
  report: getIcon('report'),
  company: getIcon('company'),
  camera: getIcon('camera')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'general',
  //   items: [
  //     {
  //       title: 'app',
  //       path: PATH_DASHBOARD.general.app,
  //       icon: ICONS.dashboard
  //     },
  //     { title: 'e-commerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
  //     { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
  //     { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
  //     { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking }
  //   ]
  // },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      // MANAGEMENT : USER
      {
        title: 'user',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        children: [
          // { title: 'profile', path: PATH_DASHBOARD.user.profile },
          // { title: 'cards', path: PATH_DASHBOARD.user.cards },
          { title: 'list', path: PATH_DASHBOARD.user.list },
          { title: 'create', path: PATH_DASHBOARD.user.newUser }
          // { title: 'edit', path: PATH_DASHBOARD.user.editById }
          // { title: 'account', path: PATH_DASHBOARD.user.account }
        ]
      },
      {
        title: 'Companies',
        path: PATH_DASHBOARD.companies.root,
        icon: ICONS.company,
        children: [
          { title: 'list', path: PATH_DASHBOARD.companies.list },
          { title: 'create', path: PATH_DASHBOARD.companies.newCompany }
        ]
      },
      {
        title: 'contacts',
        path: PATH_DASHBOARD.contacts.root,
        icon: ICONS.customer,
        children: [
          { title: 'list', path: PATH_DASHBOARD.contacts.list },
          { title: 'create', path: PATH_DASHBOARD.contacts.newContact }
        ]
      },
      {
        title: 'vehicles',
        path: PATH_DASHBOARD.vehicles.root,
        icon: ICONS.car,
        children: [
          { title: 'list', path: PATH_DASHBOARD.vehicles.list },
          { title: 'create', path: PATH_DASHBOARD.vehicles.newVehicle }
        ]
      },
      {
        title: 'drivers',
        path: PATH_DASHBOARD.drivers.root,
        icon: ICONS.driver,
        children: [
          { title: 'list', path: PATH_DASHBOARD.drivers.list },
          { title: 'create', path: PATH_DASHBOARD.drivers.newDriver }
        ]
      },
      {
        title: 'sites',
        path: PATH_DASHBOARD.contactSite.root,
        icon: ICONS.customer,
        children: [
          { title: 'list', path: PATH_DASHBOARD.contactSite.list },
          { title: 'create', path: PATH_DASHBOARD.contactSite.newContactSite }
        ]
      }

      // MANAGEMENT : E-COMMERCE
      // {
      //   title: 'e-commerce',
      //   path: ``,
      //   icon: ICONS.cart,
      //   children: [
      //     { title: 'shop', path: `` },
      //     { title: 'product', path: ``.productById },
      //     { title: 'list', path: `` },
      //     { title: 'create', path: ``.newProduct },
      //     { title: 'edit', path: ``.editById },
      //     { title: 'checkout', path: `` },
      //     { title: 'invoice', path: ``.invoice }
      //   ]
      // },

      // MANAGEMENT : BLOG
      // {
      //   title: 'blog',
      //   path: PATH_DASHBOARD.blog.root,
      //   icon: ICONS.blog,
      //   children: [
      //     { title: 'posts', path: PATH_DASHBOARD.blog.posts },
      //     { title: 'post', path: PATH_DASHBOARD.blog.postById },
      //     { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
      //   ]
      // }
    ]
  },

  // APP
  // ----------------------------------------------------------------------
  {
    subheader: 'weighbridge',
    items: [
      // {
      //   title: 'mail',
      //   path: ``,
      //   icon: ICONS.mail,
      //   info: <Label color="error">2</Label>
      // },
      // { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
      // { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
      {
        title: 'Polling Transactions',
        path: PATH_DASHBOARD.jobs.list,
        icon: ICONS.kanban
      },
      {
        title: 'Ticket Transactions',
        path: PATH_DASHBOARD.transactions.list,
        icon: ICONS.transactions
        // children: [
        //   { title: 'list', path: PATH_DASHBOARD.transactions.list }
        //   { title: 'create', path: PATH_DASHBOARD.contacts.newContact }
        // ]
      },

      {
        title: 'Ticket Transactions Reports',
        path: PATH_DASHBOARD.reports.list,
        icon: ICONS.report
      },
      {
        title: 'Camera Feeds',
        path: PATH_DASHBOARD.cameras.list,
        icon: ICONS.camera
      }
    ]
  }
];

export default sidebarConfig;
